import { render, staticRenderFns } from "./largeScreenDisplay.vue?vue&type=template&id=291d4b0a&scoped=true"
import script from "./largeScreenDisplay.vue?vue&type=script&lang=js"
export * from "./largeScreenDisplay.vue?vue&type=script&lang=js"
import style0 from "./largeScreenDisplay.vue?vue&type=style&index=0&id=291d4b0a&prod&lang=less&scoped=true"
import style1 from "./largeScreenDisplay.vue?vue&type=style&index=1&id=291d4b0a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d4b0a",
  null
  
)

export default component.exports